import styled, { css } from 'styled-components';
import { remCalc } from '@prisjakt/ui-base';
import { Size } from './types';

const lineHeight = (size?: Size) => {
  switch (size) {
    case 'tiny':
      return 12;
    case 'small':
      return 16;
    default:
      return 18;
  }
};

type PropertyListProps = {
  size?: Size;
  maxRows?: number;
  toneDown?: boolean;
};

export const PropertyList = styled.div<PropertyListProps>(
  props => css`
    line-height: ${remCalc(lineHeight(props.size))};
    max-height: ${props.maxRows
      ? remCalc(props.maxRows * lineHeight(props.size) - 1)
      : 'none'};
    overflow: ${props.maxRows ? 'hidden' : 'visible'};
    color: ${props.toneDown
      ? props.theme.text.secondary
      : props.theme.text.primary};
  `
);

const placeholderHeight = (size: Size) => {
  switch (size) {
    case 'tiny':
      return 14;
    case 'small':
      return 18;
    default:
      return 21;
  }
};

type PlaceHolderPropertyProps = {
  toneDown?: boolean;
  size: Size;
};
export const PlaceholderProperty = styled.li<PlaceHolderPropertyProps>`
  background: ${props =>
    props.toneDown ? props.theme.colors.base100 : props.theme.colors.base200};
  height: ${props => remCalc(placeholderHeight(props.size))};
  width: 200px;
  border-radius: 3px;
`;
